import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import OpusInfo from '../views/OpusInfo.vue';
import OpusReveal from "../views/OpusReveal";
import WinnersList from "../views/WinnersList";
import UploadOpus from "../views/UploadOpus";
import LoginAgreement from "../views/LoginAgreement"

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    children:[
      {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
          title: '登录注册'
        }
      },
      {
        path: '/opusInfo',
        name: 'opusInfo',
        component: OpusInfo,
        meta: {
          title: '作品详情'
        }
      },
      {
        path: '/opusReveal',
        name: 'opusReveal',
        component: OpusReveal,
        meta: {
          title: '作品展示'
        }
      },
      {
        path: '/winnersList',
        name: 'winnersList',
        component: WinnersList,
        meta: {
          title: '获奖名单'
        }
      },
      {
        path: '/uploadOpus',
        name: 'uploadOpus',
        component: UploadOpus,
        meta: {
          title: '上传作品'
        }
      },
      {
        path: '/loginAgreement',
        name: 'loginAgreement',
        component: LoginAgreement,
        meta: {
          title: '用户登录协议'
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
